/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { RadioButtonValg, RadioButtonValgModel } from './RadioButtonValg';
import { RadioButtonDisplay } from './ValgDisplayFunctions';
import VeilederStegComponent, { VeilederStegBaseProps, VeilederStegDefaultProps } from './VeilederStegComponent';
import getLabelValue from '../Utilities/InputUtilities';
import Valg from '../Models/Valg';
import { EpiAppStateMedSteg } from '../Store/Types';
import { connect } from 'react-redux';
import { EpiContext } from '../Store/EpiContext/Types';
import { setCollapsed } from '../Store/StegVisning/Actions';
import contentResolver from '../Utilities/EpiContentResolver';
import { hasParentWithClass } from '../Utilities/ElementUtilies';

type RadioButtonsStegOwnProps<T> = VeilederStegDefaultProps &
    VeilederStegBaseProps & {
        sporsmal: keyof T;
        value?: Valg<string>;
        valg: Array<RadioButtonValgModel<T>>;
        onInputChange(valg: Valg<string>): void;
    };

type RadioButtonsStegProps<T> = RadioButtonsStegOwnProps<T> & MapStateToProps<T> & MapDispatchToProps;

class RadioButtonsStegComponent<T> extends React.PureComponent<RadioButtonsStegProps<T>> {
    static defaultProps: VeilederStegDefaultProps = {
        neverCollapse: false,
    };

    constructor(props: RadioButtonsStegProps<T>) {
        super(props);

        this.onInputChange = this.onInputChange.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
    }

    onMouseUp = (event: React.MouseEvent): void => {
        const { neverCollapse, sporsmalId, stegVisningSetCollapsed } = this.props;
        if (
            neverCollapse !== true &&
            event.target != null &&
            hasParentWithClass(event.target as Element, 'c-radio-input')
        ) {
            stegVisningSetCollapsed({ id: sporsmalId, isCollapsed: true });
        }
    };

    onInputChange = (e: React.FormEvent<HTMLDivElement>): void => {
        const { onInputChange } = this.props;
        const inputSource = e.target as HTMLInputElement;
        const newValue = {
            displayValue: getLabelValue(inputSource) as string,
            value: inputSource.value,
            id: inputSource.id,
        };

        onInputChange(newValue);
    };

    render(): JSX.Element {
        const {
            sporsmalId,
            valg,
            tittel,
            forklaring,
            sporsmal,
            neverCollapse,
            classModifier,
            customBottomRow,
            value,
            epiContext,
        } = this.props;

        const gruppe = sporsmalId;
        const radioValg = valg.map((v: RadioButtonValgModel<T>) =>
            RadioButtonValg<T>(gruppe, v.id, v.value, v.tekst, value ? value.id === v.id : false, epiContext),
        );

        const display = value ? RadioButtonDisplay(gruppe, value) : null;
        return (
            <VeilederStegComponent
                sporsmalId={sporsmalId}
                tittel={tittel}
                forklaring={forklaring}
                inputArea={
                    <div className="c-veileder__inputomrade">
                        <fieldset className="c-veileder__fieldset">
                            <legend>
                                <span className="c-veileder__undersporsmal">{contentResolver(epiContext, sporsmal)}</span>
                            </legend>
                            <div className="c-veileder__radioknapper-container" onMouseUp={this.onMouseUp} onChange={this.onInputChange}>
                                {radioValg}
                            </div>
                        </fieldset>
                    </div>
                }
                displayElement={display}
                canCollapse={value !== undefined}
                neverCollapse={neverCollapse}
                classModifier={classModifier}
                customBottomRow={customBottomRow}
            />
        );
    }
}

interface MapStateToProps<T> {
    epiContext: EpiContext<T>;
}

interface MapDispatchToProps {
    stegVisningSetCollapsed: typeof setCollapsed;
}

export default function RadioButtonsStegContainer<T>() {
    return connect(
        (state: EpiAppStateMedSteg<T>): MapStateToProps<T> => {
            return {
                epiContext: state.epiContext,
            };
        },
        { stegVisningSetCollapsed: setCollapsed },
    )(RadioButtonsStegComponent as new (props: RadioButtonsStegProps<T>) => RadioButtonsStegComponent<T>);
}
